exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".answer[data-v-534deba2]{border-top:1px solid #ddd;border-bottom:1px solid #ddd;overflow:hidden}.slide-fade-enter-active[data-v-534deba2]{transition:all .3s ease;display:block;height:100%}.slide-fade-enter[data-v-534deba2],.slide-fade-leave-active[data-v-534deba2]{opacity:0;height:0;border:0}", ""]);

